import { render } from "./NoticeWrapper.vue?vue&type=template&id=43641335"
import script from "./NoticeWrapper.vue?vue&type=script&lang=js"
export * from "./NoticeWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kudamoi/projects/freedom/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__